import { useEffect, useState } from "react";
import "../Assets/TestimonialsSection.css";
import { siteService } from "../services/api";

const TestimonialsSection = () => {
  const fallbackTestimonials = [
    {
      id: 1,
      name: "Aarav Sharma",
      position: "Founder, UrbanKicks India",
      rating: 5,
      text: "Blue Panda turned our social media strategy around. Their Meta ads campaign and custom video reels brought us a 3x increase in online orders within just two months. Highly recommended!",
    },
    {
      id: 2,
      name: "Priya Patel",
      position: "Marketing Lead, Zenith Health",
      rating: 5,
      text: "The UI/UX redesign and local SEO optimization gave our brand a fresh, modern feel. We saw an instant spike in inbound inquiries and customer engagement!",
    },
    {
      id: 3,
      name: "Rohan Mehta",
      position: "CEO, Apex Financials",
      rating: 5,
      text: "Working with Blue Panda has been an absolute pleasure. Their team is creative, highly responsive, and consistently delivers ROI-focused marketing campaigns.",
    },
  ];
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);

  useEffect(() => {
    siteService
      .getTestimonials()
      .then((response) => {
        const apiTestimonials = response.data.results || response.data;
        if (apiTestimonials.length) setTestimonials(apiTestimonials);
      })
      .catch((error) => console.error("Error fetching testimonials:", error));
  }, []);

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h3
            className="testimonials-subtitle"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            Client Testimonials
          </h3>
          <h2
            className="testimonials-title"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="800"
          >
            What People Say
          </h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <div
              key={item.id || index}
              className="testimonial-card"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
              data-aos-duration="600"
            >
              {item.avatar && (
                <div className="testimonial-avatar-wrapper">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="testimonial-avatar"
                  />
                </div>
              )}
              <div className="testimonial-stars">
                {"★".repeat(item.rating || 5)}
              </div>
              <h3 className="testimonial-card-title">
                {item.name || item.title}
              </h3>
              {item.position && (
                <span className="testimonial-position">{item.position}</span>
              )}
              <p className="testimonial-card-text">"{item.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { TestimonialsSection };
